import React, { useEffect, useState } from 'react';
import PropTypes from 'prop-types';
import './PulsatingLogo.css';

const PulsatingLogo = ({ show }) => {
    const [visible, setVisible] = useState(false);

    useEffect(() => {
        let timeout;

        if (show) {
            timeout = setTimeout(() => setVisible(true), 500); // Show after 0.5s
        } else {
            setVisible(false);
        }

        return () => clearTimeout(timeout); // Clean up on unmount or prop change
    }, [show]);

    if (!visible) return null;

    return (
        <div className="pulsating-logo-overlay">
            <div className="pulsating-logo-container">
                <svg id="Layer_1" data-name="Layer 1" width="75" xmlns="http://www.w3.org/2000/svg" viewBox="0 0 297.86 322.6">
                    <path
                        d="m171.88,62l-22.8,27.8L81.98,1.5c-.7-1-1.9-1.5-3.1-1.5h-28.2c-3.2,0-5,3.6-3.1,6.1l101.5,135.2,57.2-74.7c1.9-2.5.1-6.1-3.1-6.1h-28.2c-1.2,0-2.4.5-3.1,1.5Z"
                        fill="#004DA1" />
                    <path
                        d="m273.18,256l-71-94.7,94.9-124.8c1.9-2.5.1-6.2-3-6.2h-28c-1.2,0-2.3.6-3,1.5l-99,129.5,74.5,99.4c.7,1,1.9,1.5,3.1,1.5h28.4c3.2,0,5-3.6,3.1-6.2Z"
                        fill="#004DA1" />
                    <path
                        d="m24.78,66.6l71,94.6L.78,286.2c-1.9,2.5-.1,6.2,3,6.2h28c1.2,0,2.3-.6,3-1.5l99.1-129.6L59.28,62c-.7-1-1.9-1.5-3.1-1.5h-28.4c-3.1,0-4.9,3.6-3,6.1Z"
                        fill="#004DA1" />
                    <path
                        d="m126.08,260.6l22.8-27.8,67.1,88.3c.7,1,1.9,1.5,3.1,1.5h28.2c3.2,0,5-3.6,3.1-6.1l-101.5-135.2-57.2,74.7c-1.9,2.5-.1,6.1,3.1,6.1h28.3c1.2,0,2.3-.5,3-1.5Z"
                        fill="#004DA1" />
                </svg>

            </div>
        </div>
    );
};

PulsatingLogo.propTypes = {
    show: PropTypes.bool.isRequired,
};
export default PulsatingLogo;



// WEBPACK FOOTER //
// ./frontend/components/PulsatingLogo/PulsatingLogo.jsx